module.exports = __webpack_public_path__ + "static/media/newgen.2393f416.jpeg";